import React, { Component } from "react";
import {
    getPlacesToBuy,
    getSalesReps,
    getNationalPlacesToBuy,
    getOnlinePlacesToBuy,
    getInternationalPlacesToBuy,
    getIntlSalesReps,
    getDistributors
} from "../../../apis/dealers";
import { getSupportedCountries } from "../../../apis/locale";

import animateScrollTo from "animated-scroll-to";
import { sortByTier } from '../../../utils/wtb-utils.js';

class WTBCalls extends Component {
    constructor(props) {
        super(props);


    }

    //get national dealers
    loadNationalDealers(pushState = true) {
        this.setState({ loading: true, initialLoad: false });

        getNationalPlacesToBuy()
            .then(data => {
                const newUrl = { elementUrl: this.getUrl() };
                let stores = [];

                data.map((item) => stores.push(item.StoreName));
                if (FeaturesEnabled.GoogleTagManager) {
                    dataLayer.push(newUrl);
                    dataLayer.push(stores);
                    console.log(dataLayer);
                }

                const sortedDealers = sortByTier(data, 'national');
                this.setState({
                    dealers: sortedDealers,
                    loading: false,
                    error: false
                });
            })

            .catch(error => {
                console.log(error);
                this.setState({
                    loading: false
                });
            });
        if (pushState) history.pushState(null, document.title, this.getUrl());
    }

    //get online dealers
    loadOnlineDealers(pushState = true) {
        this.setState({ loading: true, initialLoad: false });

        getOnlinePlacesToBuy()
            .then(data => {
                const newUrl = { elementUrl: this.getUrl() };
                let stores = [];

                data.map((item) => stores.push(item.StoreName));
                if (FeaturesEnabled.GoogleTagManager) {
                    dataLayer.push(newUrl);
                    dataLayer.push(stores);
                    console.log(dataLayer);
                }
                const sortedDealers = sortByTier(data, 'online');
                this.setState({
                    dealers: sortedDealers,
                    loading: false,
                    error: false
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    loading: false
                });
            });
        if (pushState) history.pushState(null, document.title, this.getUrl());
    }

    //get countries for select box
    loadCountries() {
        getSupportedCountries()
            .then(data => {
                this.setState({
                    countries: data
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    //get international dealers
    loadInternationalDealers(pushState = true) {
        this.setState({ loading: true, initialLoad: false });
        const post = {
            country: this.state.country
        };

        getInternationalPlacesToBuy(post)
            .then(data => {
                if (pushState) history.pushState(null, document.title, this.getUrl());
                const newUrl = { country: this.state.country, url: this.getUrl(), event: 'where-to-buy-intl' };
                let stores = [];

                data.map((item) => stores.push(item.StoreName));
                if (FeaturesEnabled.GoogleTagManager) {
                    dataLayer.push(newUrl);
                    dataLayer.push(stores);
                    console.log(dataLayer);
                }
                console.log(this.getUrl());

                const sortedDealers = sortByTier(data, 'intl');
                this.setState({
                    dealers: sortedDealers,
                    loading: false,
                    firstLoad: false,
                    error: false
                });
            })

            .catch(error => {
                console.log(error);
                this.setState({
                    loading: false
                });
            });

        getIntlSalesReps(post)
            .then(data => {
                this.setState({
                    salesReps: data
                });

                this.getSaleRepsVideoData(data);
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    loading: false
                });
            });
    }

    // api call method used to call dealer api and get back vendors within radius of users input
    apiCall(pushState = true) {
        if (this.state.zipcode !== "" && this.state.firstLoad === false) {
            this.setState({
                city: "",
                state: ""
            });
        }
        
        if(this.state.city || this.state.state || this.state.zipcode)
        {
            this.setState({ loading: true, firstLoad: false, initialLoad: false });

            const post = {
                nodeId: 0,
                zipcode: this.state.zipcode,
                distance: this.state.distance,
                city: this.state.city,
                state: this.state.state,
                parentPath: ""
            };

            const distributorAndRepParams = {
                city: this.state.city,
                state: this.state.state,
                zipcode: this.state.zipcode
            };
            
            //api call to dealers api with post object
            getPlacesToBuy(post)
                .then(data => {
                    let stores = [];
                    const newUrl = this.state.zipcode !== '' ? { zipcode: this.state.zipcode, url: this.getUrl(), event: 'where-to-buy-local' }
                        : { zipcode: 'undefined', city: this.state.city, state: this.state.state, url: this.getUrl(), event: 'where-to-buy-local' };
                    const newStore = data.map((item) =>
                        item.dealersOrStores.map((account) => account.accountName)
                    );
                    newStore[1].map((item) => stores.push(item));
                    if (FeaturesEnabled.GoogleTagManager) {
                        dataLayer.push(newUrl);
                        dataLayer.push(stores);
                        console.log(dataLayer);
                    }

                    console.log(this.getUrl());
                    if (pushState) history.pushState(null, document.title, this.getUrl());

                    const sortedDealers = sortByTier(data, 'local');
                    if (data.length > 0) {
                        this.setState({
                            dealers: sortedDealers,
                            loading: false,
                            error: false,
                            userLat: data[0].latitude,
                            userLng: data[0].longitude
                        });
                    } else {
                        this.setState({
                            dealers: sortedDealers,
                            error: true,
                            loading: false
                        });
                    }

                    //checks for any vendors in each element of incoming json array of categories and scrolls to map if there are any
                    data.map(item => {
                        if (item.dealersOrStores.length) {
                            return animateScrollTo(400);
                        }
                    });
                    this.setPrevStateItems();
                })
                .catch(error => {
                    console.log(error);
                    this.setState({
                        loading: false
                    });
                });

            getSalesReps(distributorAndRepParams)
                .then(data => {
                    this.setState({
                        salesReps: data
                    });

                    this.getSaleRepsVideoData(data);
                })
                .catch(error => {
                    console.log(error);
                    this.setState({
                        loading: false
                    });
                });

            getDistributors(distributorAndRepParams)
                .then(data => {
                    const sortedDistributors = sortByTier(data, 'dist');
                    this.setState({
                        distributors: sortedDistributors
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.setState({
                        loading: false
                    });
                });
        }
        else {
            this.setState({ firstLoad: false, initialLoad: false, dealers: [] })
        }
       
    }

    getSaleRepsVideoData(reps) {
        if (reps) {
            const videos = [];
            reps.map(item => {
                if (item.VideoLink) {
                    videos.push({
                        Url: item.VideoLink,
                        Title: item.VideoTitle,
                        Id: item.ContactId
                    });
                }
            });

            this.setState({
                videoItems: videos
            });
        }
    }
}

export default WTBCalls;
